import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { isDemoMode } from './DemoBanner';

import { API_BASE as API } from '../config';

export const trackDemoEvent = (event, meta = {}) => {
  if (!isDemoMode()) return;
  const token = sessionStorage.getItem('auth_token');
  // Only track if user has a session (cookie or token)
  if (!token && !document.cookie.includes('token=')) return;
  axios.post(`${API}/demo/track`, { event, meta }, { withCredentials: true }).catch(() => {});
};

export const useDemoPageTracker = () => {
  const location = useLocation();
  useEffect(() => {
    if (!isDemoMode()) return;
    trackDemoEvent('page.view', { path: location.pathname });
  }, [location.pathname]);
};
